import { create } from "zustand";
import type { Equipment } from "../types";

interface EquipmentState {
	modalOpen: boolean;
	editingItem: Equipment | null;
	defaultOrganizationId: string | null;
}

interface EquipmentActions {
	openCreateModal: (organizationId?: string) => void;
	openEditModal: (item: Equipment) => void;
	closeModal: () => void;
}

type EquipmentStore = EquipmentState & EquipmentActions;

export const useEquipmentStore = create<EquipmentStore>((set) => ({
	modalOpen: false,
	editingItem: null,
	defaultOrganizationId: null,

	openCreateModal: (organizationId) => {
		set({ modalOpen: true, editingItem: null, defaultOrganizationId: organizationId ?? null });
	},

	openEditModal: (item) => {
		set({ modalOpen: true, editingItem: item });
	},

	closeModal: () => {
		set({ modalOpen: false, editingItem: null, defaultOrganizationId: null });
	},
}));
